<template>
  <div>
    <div ref="chart" style="width: 100%; height: 185px;"></div>
  </div>
</template>
<script>
import 'amcharts3';
import 'amcharts3/amcharts/serial';
import 'amcharts3/amcharts/themes/light';
import { isEmpty } from 'lodash';
import dateMixin from '@/mixins/date';
import moment from 'moment';

export default {
  name: 'daily-shipments',
  mixins: [dateMixin],
  data() {
    return {
      cached_data: {},
    };
  },
  props: {
    range: {
      type: String,
      required: true,
    },
    startDate: {
      type: String,
      required: true,
    },
    endDate: {
      type: String,
      required: true,
    },
  },
  watch: {
    range(newRange) {
      if (this.cached_data.range !== newRange) {
        this.createChart();
        this.cached_data.range = newRange;
      }
    },
    startDate(date) {
      if (this.cached_data.start_date !== date) {
        this.createChart();
        this.cached_data.start_date = date;
      }
    },
    endDate(date) {
      if (this.cached_data.end_date !== date) {
        this.createChart();
        this.cached_data.end_date = date;
      }
    },
  },
  methods: {
    createChart: async function createChart() {
      setTimeout(async () => {
        const { chart: chartElem } = this.$refs;
        this.setUpHeight();

        if (chartElem) chartElem.innerHTML = '<p class="no__data">Loading...</>';
        const resp = await this.loadData('shipment_md/shipments/LOAD_DAILY_SHIPMENTS');
        const dataProvider = resp.map(a => ({
          date: this.formatDate(a.date),
          value: a.count,
        }));

        const startHumanize = this.formatDate(this.startDate);
        const endHumanize = this.formatDate(this.endDate);
        const subTitle = moment(this.startDate).isSame(this.endDate) ? startHumanize : `${startHumanize} - ${endHumanize}`;

        const chartConfig =
        {
          path: 'dist/amcharts/',
          type: 'serial',
          fontFamily: "'Open Sans', sans-serif",
          theme: 'light',
          titles: [
            { text: this.getChartTitle(), size: 17 },
            { text: subTitle, bold: false },
          ],
          categoryField: 'date',
          categoryAxis: {
            gridPosition: 'start',
            labelRotation: 45,
          },
          chartCursor: {
            zoomable: false,
          },
          valueAxes: [
            {
              position: 'left',
              title: 'Count of Shipment',
              titleBold: false,
            },
          ],
          graphs: [
            {
              type: 'column',
              valueField: 'value',
              fillAlphas: 0.8,
            },
          ],
          dataProvider,
        };

        if (isEmpty(resp)) {
          if (chartElem) chartElem.innerHTML = '<p class="no__data">No Data Available</>';
        } else {
          window.AmCharts.makeChart(chartElem, chartConfig);
          this.removeChartTitleLink();
        }
      }, 5e2);
    },
    getChartTitle() {
      let title = this.range === 'custom' ? 'custom_date_range' : this.range;

      title = title
        .replace(new RegExp('_', 'g'), ' ')
        .replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());

      return title;
    },
    setUpHeight() {
      if (this.$refs.chart) {
        const wItem = this.$parent.$refs.item || { clientHeight: 0 };
        const newHeight = wItem.clientHeight - (39 + 5);
        this.$refs.chart.style.height = `${newHeight}px`;
      }
    },
    loadData(method) {
      return this.$store.dispatch(method, {
        start_date: this.startDate,
        end_date: this.endDate,
      });
    },
    removeChartTitleLink() {
      const amChartTitle = document.querySelectorAll('a[title="JavaScript charts"]');
      for (let i = 0; i < amChartTitle.length; i++) {
        const chartTitle = amChartTitle[i];
        chartTitle.remove();
      }
    },
  },
  mounted() {
    this.createChart();
  },
};
</script>
<style lang="sass">
.no__data
  margin-top: 0;
  margin: 8px;
  text-align: center;
</style>



// WEBPACK FOOTER //
// src/components/dashboard_widgets/DailyShipments.vue